<template>
  <v-container v-if="products">
    <v-row style="background: #132b1b;position:relative;">
      <span :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-XXL-chi'" class="product-title" style="margin-top:3%;">{{$t('products_page.title')}}</span>
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
    </v-row>
    <v-row v-if="!$vuetify.breakpoint.xs" class="pa-0">
      <v-col 
        lg="3"
        xl="3"
        sm="3"
        col="3"
        class="pa-2"
        v-for="(product,i) in products" :key="product.order"
      >
        <div v-if="i<=3" data-aos="fade-up" data-aos-duration="3000">
          <div class="gallery-box" v-if="product.order < 900" >
            <router-link :to="{ name: 'Product Info', params: { pid : product.id }}" class="overlay">
              <div class="lay"></div>
              <div :class="$i18n.locale=='en'?'DinCondB font-size-XXL':'MHeiHK font-size-XXL-chi'" class="overlay-type" >{{product[$i18n.locale].name}}</div>
            </router-link>
            <img
              :src="ip+product.thumbnail.url"
              class="gallery-pic"
            />
          </div>
          <div class="gallery-box" v-else>
            <span :class="$i18n.locale=='en'?'georgia font-size-s7':'NotoSerifTC font-size-s7-chi'" class="gallery-info">
              {{ $t('products_page.slogan1')}}
            </span>
          </div>
        </div>
        <div v-else-if="i<=7" data-aos="fade-up" data-aos-delay="1000" data-aos-duration="3000">
          <div class="gallery-box" v-if="product.order < 900" >
            <router-link :to="{ name: 'Product Info', params: { pid : product.id }}" class="overlay">
              <div class="lay"></div>
              <div :class="$i18n.locale=='en'?'DinCondB font-size-XXL':'MHeiHK font-size-XXL-chi'" class="overlay-type" >{{product[$i18n.locale].name}}</div>
            </router-link>
            <img
              :src="ip+product.thumbnail.url"
              class="gallery-pic"
            />
          </div>
          <div class="gallery-box" v-else>
            <span :class="$i18n.locale=='en'?'georgia font-size-s7':'NotoSerifTC font-size-s7-chi'" class="gallery-info">
              {{ $t('products_page.slogan2')}}
            </span>
          </div>
        </div>
        <div v-else data-aos="fade-up" data-aos-delay="1500" data-aos-duration="3000">
          <div class="gallery-box" v-if="product.order < 900">
            <router-link :to="{ name: 'Product Info', params: { pid : product.id }}" class="overlay">
              <div class="lay"></div>
              <div :class="$i18n.locale=='en'?'DinCondB font-size-XXL':'MHeiHK font-size-XXL-chi'" class="overlay-type" >{{product[$i18n.locale].name}}</div>
            </router-link>
            <img
              :src="ip+product.thumbnail.url"
              class="gallery-pic"
            />
          </div>
          <div class="gallery-box" v-else>
            <span :class="$i18n.locale=='en'?'georgia font-size-s7':'NotoSerifTC font-size-s7-chi'" class="gallery-info">
              {{ $t('products_page.slogan3')}}
            </span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="$vuetify.breakpoint.xs" class="pa-0">
      <div
        v-for="(product,i) in products.filter(p => p.order < 900)" :key="i"
        class="ma-1"
        data-aos="fade-up" data-aos-duration="3000"
        style="width:100%;overflow:hidden;"
      >
      <router-link :to="{ name: 'Product Info', params: { pid : product.id }}">
        <div style="width:100%;padding-top:42%;background:#18432B;overflow:hidden;" >
          <v-row no-gutters style="position:absolute;top:0;left:0;right:0;bottom:0;height:100%;justify-content: center;">
          <v-col cols="7" xs="7" style="height:100%;align-items: center;justify-content: center;display: flex;">
            <v-img
              :src="ip+product.thumbnail.url"
              max-width="100%"
            />
          </v-col>
          <v-col cols="5" xs="5" style="justify-content: start;align-items: flex-end;display: flex; padding: 5px 10px;">
            <span :class="$i18n.locale=='en'?'georgia':'NotoSerifTC'" class="text-start" style="color:white;">{{product[$i18n.locale].name}}</span>
          </v-col>
          </v-row >
        </div>
        </router-link>
      </div>
    </v-row>
    <v-row style="background: #132b1b;position:relative;" >
      <span id="our-valued-partners" :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-XXL-chi'" class="product-title" style="margin-top:5%;">{{$t('products_page.partners')}}</span>
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
    </v-row>
    <div class="brand-container">
      <img
        v-if="!$vuetify.breakpoint.xs"
        :src='require("../assets/product_logo.png")' 
        data-aos="fade-up" data-aos-duration="3000" data-aos-offset:="$vuetify.breakpoint.xs?0:300"
        style="width:100%"
        @load="onImgLoad('#our-valued-partners')"
      />
      <img
        v-if="$vuetify.breakpoint.xs"
        :src='require("../assets/product_logo_mobile.png")' 
        data-aos="fade-up" data-aos-duration="3000" data-aos-offset:="$vuetify.breakpoint.xs?0:300"
        style="width:100%"
        @load="onImgLoad('#our-valued-partners')"
      />
    </div>
  </v-container>
</template>

<script>

import axios from 'axios';
import * as _ from 'lodash';
var ip = "https://lorencegroup.com/api";
export default {
  name: 'Product',
  components: {
  },
  data: function () {
    return {
      products: null,
      ip: ip
    }
  },
  mounted () {
    axios.get(ip+"/products")
    .then(response => {
      let products=_.orderBy(response.data, ["order","asc"]);
      products.forEach(product => {
        product["en"] = {name: product.display_name_english}
        product["zh_TW"] = {name: product.display_name_trad_chinese}
      });
      console.log(products)
      
      products=[
        products[0],
        products[1],
        products[2],
        {order: 997},
        products[3],
        {order: 998},
        products[4],
        products[5],
        {order: 999},
        products[6],
        products[7],
        products[8]
      ]
      this.products = products;
    })
    .catch(e => {
      console.log(e)
      //this.errors.push(e)
    })
  },
  methods: {
    onImgLoad(id) {
      if(window.location.hash == id)
        this.$scrollTo(id, 2000)
    }
  }
}
</script>

<style scoped>
.gallery-box{
  position: relative;
  color: white;
  background-color: #19442A;
  width:100%;
  padding-top: 100%;
  overflow: hidden;
}
.overlay{
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  opacity: 0;
  display:flex;
  justify-content:center;
  align-items:center;
}
.lay{
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  opacity: .3;
  display:flex;
  justify-content:center;
  align-items:center;
  background: white;
  cursor: pointer;
}
.overlay-type{
  font-family:'DinCondB', Helvetica, Arial;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  color: #132b1b;
  z-index: 2;
  letter-spacing: 3px;
  display:flex;
  justify-content:center;
  align-items:center;
  cursor: pointer;
}
.overlay:hover{
  opacity: 1;
}
.overlay:hover + .lay {
  opacity: .3;
}
.overlay:hover + .gallery-pic {
  transform: scale(1.05);
}
.product-type{
  position: absolute;
  background: red;
  top:0;
  left:0;
  right:0;
  bottom:0;
}
.gallery-pic{
  background-color: #19442A;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  transition: 1s;
  width:100%;
}
.gallery-pic:hover{
  transform: scale(1.2);
}
.gallery-info{
  letter-spacing: 2.5px;
  background-color: #19442A;
  color: white;
  position: absolute;
  bottom: 4%;
  left: 6%;
  width: 70%;
  text-align: left;
  cursor:default;
  line-height: 160%;
}

.product-title{
  letter-spacing: 10px;
  padding: 3%;
  margin-top: 500px;
  color: white;
  margin: auto;
}
.mobile .product-title{
  letter-spacing: 3px;
  padding: 3%;
  color: white;
  margin: auto;
}
.brand-container{
  width: 100%;
  background: #18432B;
  padding: 50px;
  justify-content: center;
}
.mobile .brand-container{
  padding: 5px;
}
.brand-box{
  max-height: 100px;
  width:auto;
  display:inline-block;
}
.georgia{
  font-family: Georgia, 'Times New Roman', Times, serif;
}

@media (min-width: 992px){
  .our-product-txt{
    font-size: 10px;
  }
}

@media (min-width: 1264px){
  .our-product-txt{
    font-size: 15px;
  }
}  

@media (min-width: 1904px){
  .our-product-txt{
    font-size: 18px;
  }
}  
</style>